module.exports = __webpack_public_path__ + "static/media/reactimg.aeec9b39.svg";